import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import { greyMultibrandPalette } from '../../theme/colors'

interface VerticalDivider {
  vertical?: boolean
}

const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: ({ vertical }: VerticalDivider) => (vertical ? '1px' : 'auto'),
      height: ({ vertical }: VerticalDivider) => (vertical ? 'inherit' : '0'),
      backgroundRepeat: ({ vertical }: VerticalDivider) => (vertical ? 'repeat-y' : 'repeat-x'),
      backgroundImage: ({ vertical }: VerticalDivider) =>
        `linear-gradient(${vertical ? 'to top' : 'to right'}, ${
          greyMultibrandPalette[300]
        } 30%, rgba(255, 255, 255, 0) 20%)`,
      backgroundPosition: ({ vertical }: VerticalDivider) => (vertical ? '' : 'top'),
      backgroundSize: ({ vertical }: VerticalDivider) =>
        vertical ? theme.spacing(1, 2) : theme.spacing(2, 1),
      paddingTop: ({ vertical }: VerticalDivider) => (vertical ? 0 : '1px'),
    },
  }
})

interface DottedDividerProps {
  vertical?: boolean
}

const DottedDivider: React.FC<DottedDividerProps> = ({ vertical = false }) => {
  const classes = useStyles({ vertical })

  return <div className={classes.root} />
}

export default DottedDivider
